import { render } from "./Level.vue?vue&type=template&id=f406a068&scoped=true"
import script from "./Level.vue?vue&type=script&lang=js"
export * from "./Level.vue?vue&type=script&lang=js"

import "./Level.vue?vue&type=style&index=0&id=f406a068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f406a068"]])

export default __exports__